import React from 'react';
import B1Img from '../assets/images/b1.png';
import B2Img from '../assets/images/b2.png';
import B3Img from '../assets/images/b3.png';
import B4Img from '../assets/images/b4.png';
import B5Img from '../assets/images/b5.png';
import B6Img from '../assets/images/b6.png';

function SoftwareSolutions() {
  const businessTypes = [
    {
      id: 1,
      image: B1Img,
      alt: "Busy café with customers and staff",
      title: "F&B / Café"
    },
    {
      id: 2,
      image: B2Img,
      alt: "Service-based business professional",
      title: "Service Center"
    },
    {
      id: 3,
      image: B3Img,
      alt: "Modern retail clothing store",
      title: "Retail Outlet"
    },
    {
      id: 4,
      image: B4Img,
      alt: "Auto service workshop",
      title: "Workshop"
    },
    {
      id: 5,
      image: B5Img,
      alt: "Grocery store with products",
      title: "Grocery"
    },
    {
      id: 6,
      image: B6Img,
      alt: "Restaurant kitchen with chef",
      title: "Restaurant"
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">          <h2 className="text-3xl md:text-5xl font-bold text-black mb-6">
            Made for Every Kitchen. Loved by All.
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Whether it’s a coffee bar, a bustling restaurant, or a high-volume cloud kitchen — our KDS keeps your team in sync, even at peak hours.
          </p>
        </div>        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {businessTypes.map((business) => (
            <div 
              key={business.id} 
              className="relative group overflow-hidden rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={business.image}
                  alt={business.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {/* Subtle overlay */}
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/5 transition-colors duration-300"></div>
              </div>
            </div>
          ))}
        </div>        {/* Call to Action */}
        {/* <div className="text-center mt-12">
          <p className="text-gray-600 mb-6 text-lg">
            Ready to transform your business operations with our comprehensive POS software?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-vern hover:bg-red-700 text-white font-semibold py-3 px-8 rounded-full transition-colors duration-300">
              Start Free Trial
            </button>
            <button className="border-2 border-vern text-vern hover:bg-vern hover:text-white font-semibold py-3 px-8 rounded-full transition-colors duration-300">
              Schedule Demo
            </button>
          </div>
        </div> */}
      </div>
    </section>
  );
}

export default SoftwareSolutions;
